<template>
  <div id="app" class="app-wrapper">
    <AppNavbar v-if="!isTelegramMiniApp" />

    <main class="main-content">
      <router-view />
    </main>

    <FooterBar />
  </div>
</template>

<script setup>
import AppNavbar from './components/AppNavbar.vue';
import FooterBar from "@/components/FooterBar.vue";
import { ref, onMounted } from 'vue';
import { useRouter } from "vue-router";
import { useUserStore } from "@/stores/user";
import { requestNotificationPermission, setupForegroundMessages, updateAppBadge } from "@/services/notificationService";

const isTelegramMiniApp = ref(false);
const router = useRouter();
const userStore = useUserStore();

// Notification state
const unreadNotificationCount = ref(0);

onMounted(() => {
  userStore.initialize();

  // Setup Push Notifications
  requestNotificationPermission().then(granted => {
    if (granted) {
      setupForegroundMessages((payload) => {
        console.log('Foreground notification:', payload);
        // Increase badge count
        unreadNotificationCount.value++;
        updateAppBadge(unreadNotificationCount.value);
        
        // Show native browser notification even when app is open
        if (Notification.permission === 'granted') {
          const title = payload.data?.title || payload.notification?.title || 'Mudra';
          const body = payload.data?.body || payload.notification?.body || 'You have a new notification';
          new Notification(title, {
            body: body,
            icon: '/img/icons/android-chrome-192x192.png'
          });
        }
      });
    }
  });

  // ✅ Telegram detection
  if (window.Telegram && window.Telegram.WebApp) {
    isTelegramMiniApp.value = true;
    console.log('✅ Telegram Mini App detected!');
  }

  // 🔥 SEO META SYSTEM (MOST IMPORTANT)
  router.afterEach((to) => {

    // 🏷️ Title
    document.title = to.meta?.title || "Mudra Token";

    // 📄 Description
    let metaDesc = document.querySelector("meta[name='description']");

    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }

    metaDesc.setAttribute(
      "content",
      to.meta?.description || "Write stories and earn Mudra Tokens"
    );

  });

});
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  background: linear-gradient(160deg, #060d1f 0%, #0a1628 40%, #050b18 100%) !important;
  background-size: cover !important;
  background-attachment: fixed !important;
}

/* ✅ Global: Word ने cut (hyphenate) ना करो — आखो word बीजी line मा जाय */
*,
*::before,
*::after {
  hyphens: none !important;
  -webkit-hyphens: none !important;
  -ms-hyphens: none !important;
  word-break: normal;
  overflow-wrap: break-word;
}

/* main layout */
.app-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* router-view container */
.main-content {
  flex: 1;
}

/* Chart containers */
.frappe-chart,
.chart-wrapper,
.chart-container,
[data-chart-id],
svg.frappe-chart,
#chart {
  min-height: 350px !important;
  height: 100% !important;
  min-width: 300px !important;
  width: 100% !important;
  overflow: hidden;
}
</style>